var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RoleEnum } from "../types/RoleEnum";
/**
 * The single role the form shows as selected: PublisherAdmin wins over PublisherGuarantor, an empty string means
 * no role is selected (the form validation then asks for one).
 */
export var resolveGuarantorRole = function (roles) {
    if (roles === null || roles === void 0 ? void 0 : roles.includes(RoleEnum.PUBLISHER_ADMIN)) {
        return "PublisherAdmin";
    }
    if (roles === null || roles === void 0 ? void 0 : roles.includes(RoleEnum.PUBLISHER_GUARANTOR)) {
        return "PublisherGuarantor";
    }
    return "";
};
var isDualRole = function (roles) {
    return !!(roles === null || roles === void 0 ? void 0 : roles.includes(RoleEnum.PUBLISHER_ADMIN)) &&
        roles.includes(RoleEnum.PUBLISHER_GUARANTOR);
};
/**
 * The role list to submit: a dual role becomes PublisherAdmin only (the visibly selected role); any other list is
 * kept as is - an empty one stays empty for the form validation to report.
 */
export var normalizeGuarantorRoles = function (roles) {
    return isDualRole(roles)
        ? roles.filter(function (role) { return role !== RoleEnum.PUBLISHER_GUARANTOR; })
        : roles !== null && roles !== void 0 ? roles : [];
};
/**
 * The new role list after the user clicks {@code role}: always a single role. Clicking the already selected role
 * clears it only when {@code allowDeselect} is set (the create form's checkboxes), otherwise it is kept (radios).
 */
export var toggleGuarantorRole = function (currentRoles, role, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.allowDeselect, allowDeselect = _c === void 0 ? false : _c;
    if (allowDeselect && resolveGuarantorRole(currentRoles) === role) {
        return [];
    }
    return [role];
};
/**
 * Normalizes every guarantor of a publisher payload right before it is sent, so no code path - an untouched
 * guarantor loaded with a dual role included - can submit more than one role. Guarantors that already carry a
 * single role are returned unchanged; an empty role list is left empty for the form validation to report.
 */
export var normalizePublisherGuarantors = function (guarantors) {
    return guarantors === null || guarantors === void 0 ? void 0 : guarantors.map(function (guarantor) {
        var _a;
        var rolesOk = !isDualRole(guarantor.roles);
        var userRolesOk = !isDualRole((_a = guarantor.user) === null || _a === void 0 ? void 0 : _a.roles);
        if (rolesOk && userRolesOk) {
            return guarantor;
        }
        return __assign(__assign(__assign({}, guarantor), (rolesOk ? {} : { roles: normalizeGuarantorRoles(guarantor.roles) })), (userRolesOk || !guarantor.user
            ? {}
            : {
                user: __assign(__assign({}, guarantor.user), { roles: normalizeGuarantorRoles(guarantor.user.roles) }),
            }));
    });
};
